import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CtyButton } from '@circuitry-ai/doc-ui';

/** A button that opens the file dialog, and the chosen file's name. Choosing the same file again works. */
export function FilePicker({ label, buttonLabel, accept, fileName, isDisabled, onChoose }: {
  /** The input's accessible name. */
  readonly label: string;
  readonly buttonLabel: string;
  readonly accept: string;
  readonly fileName: string | null;
  readonly isDisabled?: boolean;
  readonly onChoose: (file: File) => void;
}) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        ref={inputRef}
        type="file"
        aria-label={label}
        accept={accept}
        className="hidden"
        disabled={isDisabled}
        onChange={(event) => {
          const chosen = event.target.files?.[0];
          event.target.value = '';
          if (chosen) onChoose(chosen);
        }}
      />
      <CtyButton variant="flat" size="sm" onPress={() => inputRef.current?.click()} isDisabled={isDisabled}>
        {buttonLabel}
      </CtyButton>
      <span className="text-sm text-default-500">{fileName ?? t('No file chosen')}</span>
    </div>
  );
}
